<header id="header" class="row">
    <div class="col-12">
        <admin-menu></admin-menu>
    </div>
</header>
<input type="checkbox" name="menutoggler" id="menu-toggler" [(ngModel)]="isOpened" />
<div id="page">
    <label id="menuTogglerLabel" for="menu-toggler"><i class="fa fa-bars"></i></label>
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    <app-menu></app-menu>
</div>